export const constructionProjectManagementConst = {
  path: "/single-programs/construction-project-management",
  title: "ИНЖЕНЕРНО-СТРОИТЕЛЬНЫЙ ФАКУЛЬТЕТ – УПРАВЛЕНИЕ СТРОИТЕЛЬНЫМИ ПРОЕКТАМИ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Управление строительными проектами — объединяя технологии и стратегию</h2>
      <p>
        Это практико-ориентированная программа для будущих руководителей в сфере строительства. Она сочетает знания в области инженерии,
        архитектуры, логистики, экономики и управления. Студенты осваивают полный цикл реализации проектов: от технического задания до сдачи
        объекта в эксплуатацию.
      </p>
      <p>Ключевые компетенции включают планирование ресурсов, управление сроками, оценку рисков и взаимодействие с подрядчиками.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Управление жизненным циклом строительного проекта</li>
        <li>Разработка технической и проектной документации</li>
        <li>Строительное право и нормативы ЕС</li>
        <li>Управление бюджетом и финансовый контроль</li>
        <li>BIM-технологии и цифровые инструменты</li>
        <li>Логистика и снабжение строительных площадок</li>
        <li>Управление рисками и качеством</li>
        <li>Лидерство и командная работа в проектах</li>
      </ul>
      <p>
        Обучение основано на кейсах, симуляциях, взаимодействии с реальными подрядчиками и использованием профессионального ПО (Primavera,
        MS Project, Revit и др.).
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Менеджер строительного проекта</li>
        <li>Инженер по техническому заданию (ТЗ)</li>
        <li>Координатор строительных работ</li>
        <li>Руководитель отдела капитального строительства</li>
        <li>Консультант по управлению объектами</li>
        <li>Специалист по цифровому управлению проектами (BIM, ERP)</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€55,000 до €95,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с высокой востребованностью</li>
        <li>Очное и дистанционное обучение с гибким графиком</li>
        <li>Курсы на русском или английском языке</li>
        <li>Преподаватели — практикующие менеджеры проектов</li>
        <li>Интерактивное обучение с реальными кейсами</li>
        <li>Поддержка при поступлении, формировании портфолио и трудоустройстве</li>
      </ul>
      <p>
        <strong>Строительство требует точного управления — мы этому учим</strong>
      </p>
      <p>
        Наши выпускники успешно реализуют проекты жилых комплексов, бизнес-центров, инфраструктурных объектов в странах ЕС и за их
        пределами.
      </p>
      <br />
      <p className="padding-left">«Проект — это идея, воплощенная в бетоне и стали. Мы учим воплощать точно и вовремя.»</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет на всех этапах: от выбора программы до подачи документов.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Управление строительными проектами — объединяя технологии и стратегию
    Это практико-ориентированная программа для будущих руководителей в сфере строительства. Она сочетает знания в области инженерии, архитектуры, логистики, экономики и управления. Студенты осваивают полный цикл реализации проектов: от технического задания до сдачи объекта в эксплуатацию.
    Ключевые компетенции включают планирование ресурсов, управление сроками, оценку рисков и взаимодействие с подрядчиками.
    Что вы будете изучать?
    • Управление жизненным циклом строительного проекта
    • Разработка технической и проектной документации
    • Строительное право и нормативы ЕС
    • Управление бюджетом и финансовый контроль
    • BIM-технологии и цифровые инструменты
    • Логистика и снабжение строительных площадок
    • Управление рисками и качеством
    • Лидерство и командная работа в проектах
    Обучение основано на кейсах, симуляциях, взаимодействии с реальными подрядчиками и использованием профессионального ПО (Primavera, MS Project, Revit и др.).
    Кем можно работать после окончания?
    • Менеджер строительного проекта
    • Инженер по техническому заданию (ТЗ)
    • Координатор строительных работ
    • Руководитель отдела капитального строительства
    • Консультант по управлению объектами
    • Специалист по цифровому управлению проектами (BIM, ERP)
    Зарплата в Европе: от €55,000 до €95,000 в год
    Почему выбирают нас?
    • Европейский диплом с высокой востребованностью
    • Очное и дистанционное обучение с гибким графиком
    • Курсы на русском или английском языке
    • Преподаватели — практикующие менеджеры проектов
    • Интерактивное обучение с реальными кейсами
    • Поддержка при поступлении, формировании портфолио и трудоустройстве
    Строительство требует точного управления — мы этому учим
    Наши выпускники успешно реализуют проекты жилых комплексов, бизнес-центров, инфраструктурных объектов в странах ЕС и за их пределами.
    «Проект — это идея, воплощенная в бетоне и стали. Мы учим воплощать точно и вовремя.»
    Как поступить?
    Приёмная комиссия поможет на всех этапах: от выбора программы до подачи документов.
  `,
};
